import AccountingGetAccounts from './Get'
import AccountingDetail from './AccountingDetail'
import StarShopGetAccounts from './StarshopGet.vue';
import StarshopAccountDiscrepancy from '@/views/accounting/StarshopAccountDiscrepancy.vue';
import StarshopAccountingDetail from './StarshopAccountingDetail.vue';
import AccountDiscrepancy from './AccountDiscrepancy.vue';
import Vue from 'vue';
const EventBus = new Vue();

export {
    AccountingGetAccounts,
    StarShopGetAccounts,
    AccountingDetail,
    StarshopAccountingDetail,
    EventBus,
    StarshopAccountDiscrepancy,
    AccountDiscrepancy
}